import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export default function InputFileUpload({
  handleAddPoster,
  id,
  label = "Загрузите постер",
  accept,
  onChange,
}) {
  const changeHandler =
    onChange ?? ((event) => handleAddPoster?.(event, id));

  return (
    <Button
      size="small"
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      startIcon={<CloudUploadIcon />}
    >
      {label}
      <VisuallyHiddenInput
        id={id}
        type="file"
        accept={accept}
        onChange={changeHandler}
        multiple={false}
      />
    </Button>
  );
}
